var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon material-icons base-material-icon",style:(_vm.iconStyle)},[_vm._v(" "+_vm._s(_vm.iconName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }